import { lazyWithRetry } from "@js/utils/lazy-with-retry";

export const CreateBulkOffersContentLazy = lazyWithRetry(async () => {
  const module = await import(
    /* webpackChunkName: "create-bulk-offers-content" */ "../../components/create-bulk-offers-content"
  );
  return { default: module.CreateBulkOffersContent };
});
